import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputTable, { fillArray } from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import InputTextIntegration from 'components/blocks/ManagementNewForms/Inputs/InputTextIntegration';
import { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import Loader from 'components/blocks/Loader/Loader';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import useCreatePrestacionEmpleadosHogar from 'services/record/PrestacionEmpleadosHogar/useCreatePrestacionEmpleadosHogar';
import useUpdatePrestacionEmpleadosHogarByID from 'services/record/PrestacionEmpleadosHogar/useUpdatePrestacionEmpleadosHogar';

const PrestacionEmpleadosHogar = ({ info, dataUser, onSuccess: _onSuccess }: { info: boolean; dataUser: any; onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createPrestacionEmpleadosHogar, dataCreatePrestacionEmpleadosHogar, errorCreatePrestacionEmpleadosHogar, loadingCreatePrestacionEmpleadosHogar, successCreatePrestacionEmpleadosHogar } = useCreatePrestacionEmpleadosHogar();
    const { dataUpdatePrestacionEmpleadosHogarById, errorUpdatePrestacionEmpleadosHogarById, loadingUpdatePrestacionEmpleadosHogarById, successUpdatePrestacionEmpleadosHogarById, updatePrestacionEmpleadosHogarById } = useUpdatePrestacionEmpleadosHogarByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    void _onSuccess;

    const getValue = (...values: any[]) => values.find(value => value !== undefined && value !== null);
    const buildFullName = (...values: any[]) => values
        .map((value) => `${value ?? ""}`.trim())
        .filter((value) => value.length > 0)
        .join(" ");
    const buildAddressLine = (street: any, number: any) => {
        const streetText = `${street ?? ""}`.trim();
        const numberText = `${number ?? ""}`.trim();

        if (!streetText && !numberText) {
            return null;
        }

        if (!streetText) {
            return numberText;
        }

        if (!numberText) {
            return streetText;
        }

        return `${streetText}, ${numberText}`;
    };
    const normalizeDatosEmpleador = (source: any) => {
        const raw = source?.DatosEmpleador ?? source?.DatosRelacionLaboral ?? source ?? {};

        return {
            apellidosNombre: getValue(raw?.ApellidosNombre, raw?.EmpresaNombre, null),
            ipf: getValue(raw?.IPF, raw?.DniNiePasaporte, null),
            codigoCuentaCotizacion: getValue(raw?.CodigoCuentaCotizacion, raw?.EmpresaCCC, null),
            domicilio: getValue(raw?.Domicilio, raw?.EmpresaDomicilio, null),
            numero: getValue(raw?.Numero, raw?.EmpresaNumero, null),
            codigoPostal: getValue(raw?.CodigoPostal, raw?.EmpresaCodigoPostal, null),
            localidad: getValue(raw?.Localidad, raw?.CodigoLocalidad, raw?.codigoLocalidad, raw?.EmpresaComunidadCodigo, raw?.EmpresaLocalidad, null),
            localidadDescripcion: getValue(raw?.LocalidadDescripcion, raw?.localidadDescripcion, raw?.EmpresaComunidadCodigoDescripcion, raw?.EmpresaLocalidadDescripcion, null),
            provincia: getValue(raw?.Provincia, raw?.CodigoProvincia, raw?.codigoProvincia, raw?.EmpresaProvincia, null),
            provinciaDescripcion: getValue(raw?.ProvinciaDescripcion, raw?.provinciaDescripcion, raw?.EmpresaProvinciaDescripcion, null),
            telefono: getValue(raw?.Telefono, raw?.EmpresaTelefono, null),
        };
    };
    const watchProvinciaEmpleador = watch("DatosEmpleador.EmpresaProvincia");
    const watchProvinciaDescEmpleador = watch("DatosEmpleador.EmpresaProvinciaDescripcion");
    const watchCommEmpleador = watch("DatosEmpleador.EmpresaComunidadCodigo");
    const watchCommDescEmpleador = watch("DatosEmpleador.EmpresaComunidadCodigoDescripcion");

    const hasBaseCotizacionValue = (value: any) => {
        if (value === null || value === undefined || value === '') return false;

        if (typeof value === 'number') {
            return Number.isFinite(value) && value > 0;
        }

        const numericValue = Number(String(value).replace(',', '.').trim());
        return Number.isFinite(numericValue) && numericValue > 0;
    };

    const validateBaseCotizacionMesesAnteriores = (rows: any[] = []) => {
        const safeRows = Array.isArray(rows) ? rows : [];
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;

        if (safeRows.length < 1) return "Debe haber al menos una fila en la tabla de Base de Cotización de los meses anteriores.";

        for (let index = 0; index < safeRows.length; index++) {
            const row = safeRows[index] || {};
            const year = Number(row?.Anno);
            const month = Number(row?.Mes);
            const quotedDays = Number(row?.DiasCotizados);
            const allFieldsComplete = [
                row?.Anno,
                row?.Mes,
                row?.DiasCotizados,
                row?.BaseCotizacionCCyCP,
            ].every(hasBaseCotizacionValue);

            if (!allFieldsComplete) {
                return `Debes completar todos los campos de la fila ${index + 1} antes de enviar la solicitud.`;
            }

            if (quotedDays > 31) {
                return `La línea ${index + 1} no puede tener más de 31 días cotizados.`;
            }

            if (year === currentYear && month > currentMonth) {
                return `La línea ${index + 1} no puede tener un mes superior al mes actual.`;
            }
        }

        return true;
    };



    const adaptApiResponseToDefaultValues = (data: any) => {
        //console.log(data)
        if (data) {
            const getValue = (...values: any[]) => values.find(v => v !== undefined && v !== null);
            const datosPersonales = data?.DatosPersonales || {};
            const datosEmpleador = normalizeDatosEmpleador(data);
            const datosTrabajador = data?.DatosTrabajador || {};
            const baseCotizacionRaw = getValue(
                data?.BaseCotizacionEmp,
                data?.BaseCotizacionMesesAnteriores,
                data?.BaseCotizacion?.MesesAnteriores,
                []
            );
            const baseCotizacionRows = Array.isArray(baseCotizacionRaw)
                ? baseCotizacionRaw
                : (baseCotizacionRaw ? [baseCotizacionRaw] : []);
            const emptyBaseCotizacion = {
                BackendId: null,
                Anno: null,
                Mes: null,
                DiasCotizados: null,
                BaseCotizacionCCyCP: null,
            };
            const nombreCompleto = buildFullName(
                getValue(datosPersonales?.Nombre, null),
                getValue(datosPersonales?.Apellido1, null),
                getValue(datosPersonales?.Apellido2, null),
            );
            const numeroAfiliacionSolicitante = getValue(datosPersonales?.NumeroSeguridadSocial, null);
            const ipfSolicitante = getValue(datosPersonales?.IPF, null);
            const telefonoSolicitante = getValue(datosPersonales?.Telefono, datosPersonales?.Fijo, null);
            reset({
                DatosPersonales: {
                    SolicitanteNombre: getValue(datosPersonales?.Nombre, null),
                    SolicitanteApellido1: getValue(datosPersonales?.Apellido1, null),
                    SolicitanteApellido2: getValue(datosPersonales?.Apellido2, null),
                    SolicitanteNombreCompleto: nombreCompleto,
                    SolicitanteIPF: getValue(datosPersonales?.IPF, null),
                    SolicitanteIPFTipo: getValue(datosPersonales?.IPFTipo)?.toString() || "1",

                    SolicitanteTelefono: getValue(datosPersonales?.Telefono, null),
                    SolicitanteFijo: getValue(datosPersonales?.Fijo, null),
                    SolicitanteDomicilio: getValue(datosPersonales?.Domicilio, null),
                    SolicitanteCodigoPostal: getValue(datosPersonales?.CodigoPostal, null),
                    SolicitanteProvincia: getValue(datosPersonales?.CodigoProvincia, null),
                    SolicitanteProvinciaDescripcion: getValue(datosPersonales?.Provincia, datosPersonales?.ProvinciaDescripcion, null),
                    SolicitanteComunidadCodigo: getValue(datosPersonales?.ComunidadCodigo, datosPersonales?.CodigoLocalidad, null),
                    SolicitanteComunidadCodigoDescripcion: getValue(datosPersonales?.ComunidadCodigoDescripcion, datosPersonales?.LocalidadDescripcion, null),
                    SolicitanteEmail: getValue(data?.Email, null),
                    SolicitanteFechaNacimiento: getValue(data?.FechaNacimiento, null),
                    SolicitanteNumeroSS: getValue(datosPersonales?.NumeroSeguridadSocial, null),
                    SolicitanteIRPF: getValue(data?.TipoIRPFVoluntario, null),
                },
                DatosEmpleador: {
                    ApellidosNombre: datosEmpleador.apellidosNombre,
                    IPF: datosEmpleador.ipf,
                    EmpresaNombre: datosEmpleador.apellidosNombre,
                    EmpresaCCC: datosEmpleador.codigoCuentaCotizacion,
                    EmpresaDomicilio: datosEmpleador.domicilio,
                    EmpresaNumero: datosEmpleador.numero,
                    EmpresaProvincia: datosEmpleador.provincia,
                    EmpresaProvinciaDescripcion: datosEmpleador.provinciaDescripcion,
                    EmpresaComunidadCodigo: datosEmpleador.localidad,
                    EmpresaComunidadCodigoDescripcion: datosEmpleador.localidadDescripcion,
                    EmpresaCodigoPostal: datosEmpleador.codigoPostal,
                    EmpresaTelefono: datosEmpleador.telefono,
                },
                DatosTrabajador: {
                    ApellidosNombre: getValue(nombreCompleto || null, datosTrabajador?.ApellidosNombre, null),
                    NumeroAfiliacionSeguridadSocial: getValue(numeroAfiliacionSolicitante, datosTrabajador?.NumeroAfiliacionSeguridadSocial, null),
                    IPF: getValue(ipfSolicitante, datosTrabajador?.IPF, datosTrabajador?.DniNiePasaporte, null),
                    Telefono: getValue(telefonoSolicitante, datosTrabajador?.Telefono, null),
                    TipoContratoTiempo: getValue(datosTrabajador?.TipoContrato, datosTrabajador?.TipoContratoTiempo, null)?.toString() || null,
                    TramoCotizacion: getValue(datosTrabajador?.TramoCotizacion, null),
                    FechaInicioActividad: getValue(datosTrabajador?.FechaInicioActividad, null),
                    FechaSituacionITRiesgo: getValue(datosTrabajador?.FechaSituacionITRiesgo, null),
                },
                BaseCotizacionMesesAnteriores: fillArray(
                    baseCotizacionRows.map((row: any) => ({
                        BackendId: getValue(row?.BackendId, row?.Id, null),
                        Anno: getValue(row?.Anno, row?.Anyo, row?.Año, row?.Ano, null),
                        Mes: getValue(row?.Mes, null),
                        DiasCotizados: getValue(row?.DiasCotizados, null),
                        BaseCotizacionCCyCP: getValue(row?.BaseCotizacionCCyCP, row?.BaseCotizacionCCCP, null),
                    })),
                    0,
                    emptyBaseCotizacion
                ),
                Solicitud: {
                    PrestacionSolicitada: getValue(data?.Solicitud?.PrestacionSolicitada, data?.TiposPrestacion, null)?.toString() || null,
                }
            })
        }

    }

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;
        const tipoContratoRaw = data?.DatosTrabajador?.TipoContratoTiempo
            ?? dataUser?.DatosTrabajador?.TipoContrato
            ?? dataUser?.DatosTrabajador?.TipoContratoTiempo
            ?? "";
        const tipoContratoParsed = Number.parseInt(`${tipoContratoRaw}`, 10);
        const nombreTrabajadorDesdeForm = buildFullName(
            data?.DatosPersonales?.SolicitanteNombre,
            data?.DatosPersonales?.SolicitanteApellido1,
            data?.DatosPersonales?.SolicitanteApellido2
        );
        const nombreTrabajadorDesdeApi = buildFullName(
            dataUser?.DatosPersonales?.Nombre,
            dataUser?.DatosPersonales?.Apellido1,
            dataUser?.DatosPersonales?.Apellido2
        );
        const apellidosNombreTrabajador = getValue(
            data?.DatosTrabajador?.ApellidosNombre,
            nombreTrabajadorDesdeForm || null,
            nombreTrabajadorDesdeApi || null,
            dataUser?.DatosTrabajador?.ApellidosNombre,
            null
        );
        const numeroAfiliacionTrabajador = getValue(
            data?.DatosPersonales?.SolicitanteNumeroSS,
            dataUser?.DatosPersonales?.NumeroSeguridadSocial,
            data?.DatosTrabajador?.NumeroAfiliacionSeguridadSocial,
            dataUser?.DatosTrabajador?.NumeroAfiliacionSeguridadSocial,
            null
        );
        const ipfTrabajador = getValue(
            data?.DatosTrabajador?.IPF,
            dataUser?.DatosTrabajador?.IPF,
            dataUser?.DatosTrabajador?.DniNiePasaporte,
            dataUser?.DatosPersonales?.IPF,
            null
        );
        const telefonoTrabajador = getValue(
            data?.DatosPersonales?.SolicitanteTelefono,
            data?.DatosPersonales?.SolicitanteFijo,
            dataUser?.DatosPersonales?.Telefono,
            dataUser?.DatosPersonales?.Fijo,
            data?.DatosTrabajador?.Telefono,
            dataUser?.DatosTrabajador?.Telefono,
            null
        );
        const datosEmpleadorApi = normalizeDatosEmpleador(dataUser);
        const apellidosNombreEmpleador = getValue(data?.DatosEmpleador?.ApellidosNombre, data?.DatosEmpleador?.EmpresaNombre, datosEmpleadorApi.apellidosNombre, null);
        const ipfEmpleador = getValue(data?.DatosEmpleador?.IPF, datosEmpleadorApi.ipf, null);
        const codigoCuentaCotizacionEmpleador = getValue(data?.DatosEmpleador?.EmpresaCCC, datosEmpleadorApi.codigoCuentaCotizacion, null);
        const domicilioEmpleador = getValue(data?.DatosEmpleador?.EmpresaDomicilio, datosEmpleadorApi.domicilio, null);
        const numeroEmpleador = getValue(data?.DatosEmpleador?.EmpresaNumero, datosEmpleadorApi.numero, null);
        const codigoPostalEmpleador = getValue(data?.DatosEmpleador?.EmpresaCodigoPostal, datosEmpleadorApi.codigoPostal, null);
        const codigoLocalidadEmpleador = getValue(data?.DatosEmpleador?.EmpresaComunidadCodigo, datosEmpleadorApi.localidad, null);
        const localidadDescripcionEmpleador = getValue(data?.DatosEmpleador?.EmpresaComunidadCodigoDescripcion, datosEmpleadorApi.localidadDescripcion, null);
        const codigoProvinciaEmpleador = getValue(data?.DatosEmpleador?.EmpresaProvincia, datosEmpleadorApi.provincia, null);
        const provinciaDescripcionEmpleador = getValue(data?.DatosEmpleador?.EmpresaProvinciaDescripcion, datosEmpleadorApi.provinciaDescripcion, null);
        const telefonoEmpleador = getValue(data?.DatosEmpleador?.EmpresaTelefono, datosEmpleadorApi.telefono, null);

        const datosEnvio = {
            // IDENTIFICACIÓN
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || 0,
            PrestacionId: prestacionId,

            Acepto: data?.Acepto ?? false,

            Solicitud: {
                prestacionSolicitada: data?.Solicitud?.PrestacionSolicitada ?? dataUser?.Solicitud?.PrestacionSolicitada ?? null,
            },

            // -----------------------------------
            // DATOS PERSONALES
            // -----------------------------------
            DatosPersonales: {
                nombre: dataUser?.DatosPersonales?.Nombre ?? null,
                apellido1: dataUser?.DatosPersonales?.Apellido1 ?? null,
                apellido2: dataUser?.DatosPersonales?.Apellido2 ?? null,
                ipf: dataUser?.DatosPersonales?.IPF ?? null,
                ipfTipo: dataUser?.DatosPersonales?.IPFTipo ?? 1,
                telefono: dataUser?.DatosPersonales?.Telefono ?? null,
                fijo: dataUser?.DatosPersonales?.Fijo ?? null,
                domicilio: dataUser?.DatosPersonales?.Domicilio ?? null,
                codigoPostal: dataUser?.DatosPersonales?.CodigoPostal ?? null,
                provinciaDescripcion: dataUser?.DatosPersonales?.ProvinciaDescripcion ?? dataUser?.DatosPersonales?.Provincia ?? null,
                codigoProvincia: dataUser?.DatosPersonales?.CodigoProvincia ?? null,
                codigoLocalidad: dataUser?.DatosPersonales?.CodigoLocalidad ?? null,
                localidadDescripcion: dataUser?.DatosPersonales?.LocalidadDescripcion ?? null,
                numeroSeguridadSocial: dataUser?.DatosPersonales?.NumeroSeguridadSocial ?? null
            },
            nas: numeroAfiliacionTrabajador ?? "",
            impersonadorId: dataUser?.ImpersonadorId ?? null,
            tiposPrestacion: Number(
                data?.Solicitud?.PrestacionSolicitada
                ?? dataUser?.Solicitud?.PrestacionSolicitada
                ?? dataUser?.TiposPrestacion
                ?? null
            ),
            datosEmpleador: {
                apellidosNombre: apellidosNombreEmpleador,
                ipf: ipfEmpleador,
                codigoCuentaCotizacion: codigoCuentaCotizacionEmpleador,
                domicilio: buildAddressLine(domicilioEmpleador, numeroEmpleador),
                codigoPostal: codigoPostalEmpleador,
                codigoLocalidad: codigoLocalidadEmpleador,
                localidadDescripcion: localidadDescripcionEmpleador,
                codigoProvincia: codigoProvinciaEmpleador,
                provinciaDescripcion: provinciaDescripcionEmpleador,
                telefono: telefonoEmpleador,
            },
            datosTrabajador: {
                apellidosNombre: apellidosNombreTrabajador,
                numeroAfiliacionSeguridadSocial: numeroAfiliacionTrabajador,
                dniNiePasaporte: ipfTrabajador,
                telefono: telefonoTrabajador,
                tipoContrato: Number.isNaN(tipoContratoParsed) ? null : tipoContratoParsed,
                tramoCotizacion: data?.DatosTrabajador?.TramoCotizacion ?? dataUser?.DatosTrabajador?.TramoCotizacion ?? null,
                fechaInicioActividad: data?.DatosTrabajador?.FechaInicioActividad ?? dataUser?.DatosTrabajador?.FechaInicioActividad ?? null,
                fechaSituacionITRiesgo: data?.DatosTrabajador?.FechaSituacionITRiesgo ?? dataUser?.DatosTrabajador?.FechaSituacionITRiesgo ?? null,
            },
            baseCotizacionEmp: (() => {
                const baseRows = data?.BaseCotizacionMesesAnteriores
                    ?? data?.BaseCotizacionEmp
                    ?? dataUser?.BaseCotizacionMesesAnteriores
                    ?? dataUser?.BaseCotizacionEmp
                    ?? [];

                const normalizedRows = Array.isArray(baseRows) ? baseRows : (baseRows ? [baseRows] : []);

                return normalizedRows.map((row: any) => ({
                    id: row?.BackendId ?? row?.Id ?? null,
                    "año": row?.Anno ?? row?.Anyo ?? row?.Año ?? row?.Ano ?? null,
                    mes: row?.Mes ?? null,
                    diasCotizados: row?.DiasCotizados ?? null,
                    baseCotizacionCCCP: row?.BaseCotizacionCCyCP ?? row?.BaseCotizacionCCCP ?? null,
                }));
            })()
        }

        if (info) {
            createPrestacionEmpleadosHogar(dataUser?.UsuarioId.toString(), datosEnvio, _onSuccess)

           // setBloquearEnvio(true);
        } else {
            updatePrestacionEmpleadosHogarById(dataUser?.Id, dataUser?.Id, datosEnvio)
           // setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={getValue(datosAPI?.EstadoFormulario, datosAPI?.estadoFormulario, dataUser?.EstadoFormulario, dataUser?.estadoFormulario)}
                    estadoFormularioDescripcion={getValue(datosAPI?.EstadoFormularioDescripcion, datosAPI?.estadoFormularioDescripcion, dataUser?.EstadoFormularioDescripcion, dataUser?.estadoFormularioDescripcion)}
                    fechaActualizacionEstado={getValue(datosAPI?.FechaActualizacionEstado, datosAPI?.fechaActualizacionEstado, dataUser?.FechaActualizacionEstado, dataUser?.fechaActualizacionEstado)}
                />

                <Loader activeLoader={loader || loadingCreatePrestacionEmpleadosHogar || loadingUpdatePrestacionEmpleadosHogarById} label="Cargando Formulario"></Loader>








                {/* //////////////////////////// COMIENZO FORMULARIO //////////////////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}

                <FieldsetContainer legend="" disabled={false}>

                    <p className=' mb-4 text-left parra-bold'>D/Dª
                        <InputTextIntegration
                            name="DatosEmpleador.ApellidosNombre"
                            inputType={1}
                            disabled={true}
                            minWidth={360}
                        />
                        con DNI-NIE-Pasaporte
                        <InputTextIntegration
                            name="DatosEmpleador.IPF"
                            inputType={1}
                            disabled={true}
                        />
                        en calidad de empleador, CERTIFICA:
                    </p>



                    <FormInputRadioGroup
                        labels={[
                            'Incapacidad Temporal por Contingencia Profesional.',
                            'Riesgo durante el Embarazo o Lactancia Natural.',
                            'Incapacidad Temporal por Contingencia Común.',
                            'Cuidado de menores con cáncer o enfermedad grave.'
                        ]}
                        name={'Solicitud.PrestacionSolicitada'}
                        values={[1,3,2,4]}
                        required='Es necesario marcar el tipo de prestación'
                        title='   Que son ciertos los datos relativos a las circunstancias personales, profesionales y de cotización, que se consignan a efectos de solicitar la prestación de'
                        col={6}
                    />

                </FieldsetContainer>
                <div className='mb-3'></div>
                <AccordionForm title={'Datos del Empleador'} expandedInit={false} nombreError='DatosEmpleador' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputText
                                    name='DatosEmpleador.EmpresaNombre'
                                    id='DatosEmpleador.EmpresaNombre'
                                    label='Nombre del empleador'
                                    md={6}
                                    xl={6}
                                    disabled={true}
                                />

                                <FormInputText
                                    name='DatosEmpleador.EmpresaCCC'
                                    id='DatosEmpleador.EmpresaCCC'
                                    label='Código Cuenta Cotización'
                                    md={6}
                                    xl={6}
                                    disabled={true}
                                    maxLength={11}
                                    pattern={/^[0-9]{11}$/}
                                    patternMessage='El CCC debe tener 11 digitos y números enteros'
                                />

                           

                                           

                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'DatosEmpleador.EmpresaProvincia'}
                                        watchProvinceDescription={watchProvinciaDescEmpleador}
                                        idDescription={'DatosEmpleador.EmpresaProvinciaDescripcion'}
                                        watchProvinceCode={watchProvinciaEmpleador}
                                        setValue={setValue}
                                        disabled={true}
                                    />
                                </div>

                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvinciaEmpleador}
                                        watchCommunityCode={watchCommEmpleador}
                                        watchCommunityDescription={watchCommDescEmpleador}
                                        idCode={'DatosEmpleador.EmpresaComunidadCodigo'}
                                        idDescription={'DatosEmpleador.EmpresaComunidadCodigoDescripcion'}
                                        filterByProvince={true}
                                        disabled={true}
                                    />
                                </div>
                                 <FormInputText
                                    name='DatosEmpleador.EmpresaDomicilio'
                                    id='DatosEmpleador.EmpresaDomicilio'
                                    label='Domicilio'
                                    md={4}
                                    xl={4}
                                    disabled={true}
                                />
                                <FormInputText
                                    name='DatosEmpleador.EmpresaCodigoPostal'
                                    id='DatosEmpleador.EmpresaCodigoPostal'
                                    label='Código Postal'
                                    md={4}
                                    xl={4}
                                    disabled={true}
                                    
                                />

                                <FormInputText
                                    name='DatosEmpleador.EmpresaTelefono'
                                    id='DatosEmpleador.EmpresaTelefono'
                                    label='Teléfono'
                                    md={4}
                                    xl={4}
                                    disabled={true}
                                    pattern={/^[0-9]{9}$/}
                                    patternMessage='El movil debe tener 9 digitos y números enteros'
                                />

                           

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Datos del Trabajador'} expandedInit={false} nombreError='DatosTrabajador' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputText
                                    name='DatosTrabajador.ApellidosNombre'
                                    id='DatosTrabajador.ApellidosNombre'
                                    label='Apellidos y nombre'
                                    md={6}
                                    xl={6}
                                    disabled={true}
                                />

                                <FormInputText
                                    name='DatosTrabajador.NumeroAfiliacionSeguridadSocial'
                                    id='DatosTrabajador.NumeroAfiliacionSeguridadSocial'
                                    label='Número de Afiliación Seguridad Social'
                                    md={6}
                                    xl={6}
                                    disabled={true}
                                />

                                <FormInputText
                                    name='DatosTrabajador.IPF'
                                    id='DatosTrabajador.IPF'
                                    label='DNI-NIE-Pasaporte'
                                    md={6}
                                    xl={6}
                                    disabled={true}
                                />

                                <FormInputText
                                    name='DatosTrabajador.Telefono'
                                    id='DatosTrabajador.Telefono'
                                    label='Teléfono'
                                    md={6}
                                    xl={6}
                                    disabled={true}
                                    pattern={/^[0-9]+$/}
                                    patternMessage='Solo se permiten numeros enteros'
                                />

                                <FormInputRadioGroup
                                    title='Tipo de contrato. Tiempo:'
                                    labels={['Completo', 'Parcial']}
                                    name={'DatosTrabajador.TipoContratoTiempo'}
                                    values={[1,2]}
                                    required='Es obligatorio especificar el tipo de contrato'
                                    col={12}
                                />

                                <FormInputText
                                    name='DatosTrabajador.TramoCotizacion'
                                    id='DatosTrabajador.TramoCotizacion'
                                    label='Tramo de Cotización'
                                    md={4}
                                    xl={4}
                                    disabled={false}
                                />

                                <FormInputFecha
                                    name={'DatosTrabajador.FechaInicioActividad'}
                                    id={'DatosTrabajador.FechaInicioActividad'}
                                    label={'Fecha de Inicio de la Actividad'}
                                    placeholder={''}
                                    req='La fecha de inicio de actividad es obligatoria'
                                    md={4}
                                    xl={4}
                                    col={12}
                                    disableDate={false}
                                />

                                <FormInputFecha
                                    name={'DatosTrabajador.FechaSituacionITRiesgo'}
                                    id={'DatosTrabajador.FechaSituacionITRiesgo'}
                                    label={'Fecha Situación de IT o Riesgo'}
                                    placeholder={''}
                                    req='La fecha de inicio de actividad es obligatoria'
                                    md={4}
                                    xl={4}
                                    col={12}
                                    disableDate={false}
                                    maxDate={new Date(Date.now())}
                                />

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Base de Cotizacion Meses Anteriores'} expandedInit={false} nombreError='BaseCotizacionMesesAnteriores' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="" disabled={false}>
                                <p className='fs-5 mb-2 fw-bold'>Base de cotizacion de los meses anteriores a la fecha de inicio de la prestacion</p>
                                <FormInputTable
                                    name="BaseCotizacionMesesAnteriores"
                                    heads={[
                                        'Año',
                                        'Mes',
                                        'Dias Cotizados',
                                        'Base de Cotizacion por C.C. y C.P.'
                                    ]}
                                    nameHeads={[
                                        'Anno',
                                        'Mes',
                                        'DiasCotizados',
                                        'BaseCotizacionCCyCP'
                                    ]}
                                    removeButton={true}
                                    addButton={true}
                                    widthColumn={[1, 1, 1, 2]}
                                    validateFunction={validateBaseCotizacionMesesAnteriores}
                                    inputType={[9, 7, 2, 3]}
                                />
                                

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>
















                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreatePrestacionEmpleadosHogar}
                    successUpdate={successUpdatePrestacionEmpleadosHogarById}
                    errorCreate={errorCreatePrestacionEmpleadosHogar}
                    errorUpdate={errorUpdatePrestacionEmpleadosHogarById}
                    datosAPI={datosAPI}
                    info={info}
                    BloqueoForm={[1]}
                />


                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default PrestacionEmpleadosHogar
